import { render, staticRenderFns } from "./InputLanguage.vue?vue&type=template&id=2c3cb207&scoped=true&"
import script from "./InputLanguage.vue?vue&type=script&lang=ts&"
export * from "./InputLanguage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3cb207",
  null
  
)

export default component.exports